import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  public isQuerying: boolean = false;
  public isRefreshing: boolean = false;
  public loadingSpinner: HTMLIonLoadingElement;

  constructor(private utilityService: UtilityService) {}

  public lockQuery(setRefreshing: boolean = true): boolean {
    if (this.isQuerying) {
      return false;
    }

    this.isQuerying = true;
    if (setRefreshing) {
      this.isRefreshing = true;
    }
    return true;
  }

  public unlockQuery(): void {
    this.isQuerying = false;
    this.isRefreshing = false;
  }

  public async animateQuery(): Promise<void> {
    await this.loadingSpinner?.dismiss();
    this.loadingSpinner = await this.utilityService.createDefaultSpinner();
    await this.loadingSpinner?.present();
  }

  public async stopAnimateQuery(): Promise<void> {
    await this.loadingSpinner?.dismiss();
  }

  public async lockAnimateQuery(
    setRefreshing: boolean = true
  ): Promise<boolean> {
    if (this.isQuerying) {
      return false;
    }

    this.isQuerying = true;
    if (setRefreshing) {
      this.isRefreshing = true;
    }
    await this.animateQuery();
    return true;
  }

  public async unlockStopAnimateQuery(): Promise<void> {
    await this.stopAnimateQuery();
    this.isQuerying = false;
    this.isRefreshing = false;
  }
}
